query customerQuery(
  $id: String!
  $operator: String!
  $first: Int
  $offset: Int
  $condition: BetCondition
  $filter: BetFilter
) {
  customer: accountByPlayerAccountIdAndOperatorId(
    playerAccountId: $id
    operatorId: $operator
  ) {
    id: playerAccountId
    nickname
    isFlagged
    strength
    operatorId
    firstPlacedBet
    lastActive
    profilingLabels
    latestNote: commentsByPlayerAccountIdAndOperatorId(
      orderBy: CREATED_AT_DESC
      first: 1
    ) {
      nodes {
        id: commentId
        createdAt
        updatedAt
        edited
        content: commentContent
      }
    }
    kpi: accountKpiByPlayerAccountIdAndOperatorId {
      volume
      averageBetSize: averageStake
      holdPercentage
      edgePercentage
      singlesPercentage
      pnl
      betsCount
    }
    sportKpis: accountSportKpisByPlayerAccountIdAndOperatorId {
      nodes {
        sportId
        sportPartition
      }
    }
    betTypeKpis: accountBetTypeKpisByPlayerAccountIdAndOperatorId {
      nodes {
        betType
        betTypePartition
      }
    }
    eventStateKpis: accountInPlayKpisByPlayerAccountIdAndOperatorId {
      nodes {
        inPlay
        inPlayPartition
      }
    }
    bets: betsByPlayerAccountIdAndOperatorId(
      first: $first
      offset: $offset
      condition: $condition
      filter: $filter
      orderBy: ACCEPTANCE_TIME_DESC
    ) {
      totalCount
      nodes {
        acceptanceTime
        betId
        operatorId
        playerAccountId
        betStake
        betType
        betPayout
        betActions
        inferredDecimalPrice
        inferredBetProbability
        inferredOriginalFormattedPrice
        isFlagged
        flagType
        isActive
        betPartGroups
        betOutcome
        accountInfo: accountByPlayerAccountIdAndOperatorId {
          maxBetPercentage
          stakeFactor
        }
        betPartsByBetId {
          nodes {
            betId
            price
            limit
            marketId
            marketType
            marketSummary
            selection
            selectionId
            selectionType
            betPartOutcome
            event {
              eventName
              eventId
              competition {
                competitionName
              }
              competitors
              sportId
              sport {
                sportLabel
              }
              isUsaView
            }
            specialMarket {
              specialName
              selections
              events {
                edges {
                  node {
                    eventName
                  }
                }
              }
              competitions {
                nodes {
                  competitionName
                }
              }
            }
          }
        }
      }
    }
  }
}
